import { h, render, Component } from 'preact';
import classnames from 'classnames/dedupe';

import axios from 'axios';

import Loadable from 'react-loadable';
import Toolbar from 'q-mdc/elements/material-toolbar';
import Button from 'q-mdc/elements/material-button';
import LayoutGrid from 'q-mdc/elements/material-layout-grid';
import ToolbarRow from 'q-mdc/elements/material-toolbar-row';
import ToolbarSection from 'q-mdc/elements/material-toolbar-section';
import ToolbarTitle from 'q-mdc/elements/material-toolbar-title';
import Dialog from 'q-mdc/elements/material-dialog';
import Cookies from 'universal-cookie';
import debounce from 'lodash.debounce';

// import Hamburger from '../hamburger';

import { Menu as MenuIcon, Quikr, Back } from '../icons/headerIcons';
import showOrHide from '../hoc/showOrHide';
import MyAccountMenu from '../myAccount';
// import Close from '../icons/close';
import Location from '../icons/location';

import CitySelection from '../desktop/city';
import { getEventTrackGA } from '../../helpers/ga';
import { detectLocations, searchCityDefaultCallback } from '../../helpers/location';
import { getCurrentCity } from '../../helpers';
import { ALL_INDIA , CITY_COOKIE_TTL, COOKIE_DOMAIN } from '../../helpers/constants';

import { isAndroid } from '../../helpers/userAgent';
import get from 'lodash.get';
import AddToHomeScreen from '../addToHomescreen';
import SearchComponent from '../search';
import MediaQuery from '../../hoc/mediaQuery';
import SwitchBanner from '../SwitchBanner/SwitchBanner';
import '@material/typography/mdc-typography.scss';
import './index.scss';

const cookies = new Cookies();

const LoadableSearchPopup = Loadable({
	loader: () => import('../city'),
	loading: () => <div />,
	render(loaded, props) {
		let CitySearchPopup = loaded.default;
		return <CitySearchPopup {...props} />;
	}
});

const LoadableNotificationPopup = Loadable({
	loader: () => import('../notification'),
	loading: () => <div />,
	render(loaded, props) {
		let NotificationPopup = loaded.default;
		return <NotificationPopup {...props} />;
	}
});

const LoadableHamburger = Loadable({
	loader: () => import('../hamburger'),
	loading: () => <div />,
	render(loaded, props) {
		let Hamburger = loaded.default;
		return <Hamburger {...props} />;
	}
});

const LoadableMarketTalkButton = Loadable({
	loader: () => import('../MarketTalkButton'),
	loading: () => <div />,
	render(loaded, props) {
		let MarketTalkButton = loaded.default;
		return <MarketTalkButton {...props} />;
	}
});

const LoadableViewinAppFAB = Loadable({
	loader: () => import('../FloatingActionButton'),
	loading: () => <div />,
	render(loaded, props) {
		let ViewinAppFAB = loaded.default;
		return <ViewinAppFAB {...props} />;
	}
});

const LoadableQkrAppWidget = Loadable({
	loader: () => import('../QkrAppWidget'),
	loading: () => <div />,
	render(loaded, props) {
		let QkrAppWidget = loaded.default;
		return <QkrAppWidget {...props} />;
	}
});

class Header extends Component {

	constructor(props) {
		super(props);
		this.state = {
			results: [],
			error: null,
			value: null,
			cityPopup: false,
			notificationPopup: false,
			topCitiesList: false,
			drawerOpen: null,
			showAddtoHomeScreen: false,
			showBottomBar: false
		};
		this.debouncedHandleCitySearch = debounce(this.handleCitySearch, 250, { maxWait: 500 }).bind(this);
	}

	checkLocationStatus = () => {
		if (!navigator.geolocation) {
			return false;
		}
		if (!navigator.permissions) {
			return false;
		}
		navigator.permissions.query({ name: 'geolocation' }).then((result) => {
			const { searchCityCallback, g_id = 0, match } = this.props;

			if (result.state === 'prompt') {
				detectLocations((res) => {
					getEventTrackGA({ category: 'quikr_pwa', action: 'location_permission', label: 'allowed' });
					const { cityId, cityName } = res;

					cookies.set('new_prefer_city', cityName, {
						path: '/',
						maxAge: CITY_COOKIE_TTL,
						domain: COOKIE_DOMAIN
					});
					cookies.set('prefer_city_id', cityId, {
						path: '/',
						maxAge: CITY_COOKIE_TTL,
						domain: COOKIE_DOMAIN
					});

					if (typeof searchCityCallback === 'function') {
						searchCityCallback(cityId, cityName, g_id, match);
					} else {
						searchCityDefaultCallback(cityId, cityName, g_id, match);
					}
				}, (err) => {
					if (err && err.code === 1) {
						// User denied the permission
						getEventTrackGA({ category: 'quikr_pwa', action: 'location_permission', label: 'denied' });
					}
				});
			}
		});
	}

	componentDidMount() {
		const city = getCurrentCity();
		if (city === ALL_INDIA) {
			this.checkLocationStatus();
		}

		if (window && window.matchMedia && !window.matchMedia('(display-mode: standalone)').matches) {
			this.setState({
				showAddtoHomeScreen: true
			});
		}
		
		if (typeof window !== 'undefined') {
			const searchParams = new URLSearchParams(window.location.search);
			const utmParams = {};
			for (const item of ['utm_source', 'utm_medium', 'utm_campaign']) {
				if (searchParams.has(item)) {
					const val = searchParams.get(item);
					if (val) {
					   utmParams[item] = encodeURIComponent(val);
					}
				}
			}
			Object.keys(utmParams).length &&
				sessionStorage.setItem('utm_params', JSON.stringify(utmParams));
		}
	}

	/**
	* This method is called whenever the props or state changes
	* @return {Object} Context of child components
	*/
	getChildContext() {
		const context = {};
		context.pageType = this.getPageTypeFromProps();
		return context;
	}

	getPageTypeFromProps = () => {
		const { getPageType } = this.props;
		if (typeof getPageType === 'function' && typeof window !== 'undefined') {
			return getPageType();
		}
		return 'other';
	}

	redirectToPostAd = (e) => {
		const pageType = this.getPageTypeFromProps();
		const gaEventObject = { category: 'quikr_pwa', action: `quikr_pwa_${pageType}_postad`, label: `quikr_pwa_${pageType}_postad_click` };
		getEventTrackGA(gaEventObject);
		window.location = `http://${window.location.host}/post-classifieds-ads`;
	};

	setCityAndSearch = (event) => {
		const { target: { value } } = event;
		this.setState({
			topCitiesList: false,
			value
		});
		this.debouncedHandleCitySearch(event);

	}

	updateCityList = (cityList) => {
		this.setState({
			results: cityList,
			err: null
		});
	}

	handleCitySearch = (event) => {

		const { target: { value } } = event;

		if (value === '') {
			this.setState({
				results: [],
				topCitiesList: true
			});
			return;
		}

		if (this.props.citySearchCallBack) {
			this.props.citySearchCallBack(value,this.updateCityList);
			return;
		}

		let hostname = 'www.quikr.com';
		if (window && window.location && window.location.hostname) {
			hostname = window.location.hostname;
		}

		const { international = false } = this.props;
		let params = new URLSearchParams();
		params.append('keyword', value);
		params.append('abroad', international);

		axios.post('https://feservices.quikr.com/v2/header/suggest_cities_json', params, {
			accept: 'application/json, text/javascript, */*; q=0.01',
			'accept-language': 'en-GB,en-US;q=0.9,en;q=0.8',
			'Content-Type': 'application/x-www-form-urlencoded'
		}).then((res) => {
			if (res.status === 200) {
				this.setState({
					results: res.data,
					err: null
				});
			}
			else {
				this.setState({
					results: [],
					err: 'Something went wrong'
				});
			}
		}).catch((err) => {
			this.setState({
				err,
				results: []
			});
		});
	};

	showCityPopup = () => {
		if (this.props.cityModal && window.innerWidth >= 780) {
			this.cityDialog.MDComponent.show();
		} else {
			this.setState({
				cityPopup: true,
				topCitiesList: true
			});
			const pageType = this.getPageTypeFromProps();
			const gaEventObject = { category: 'quikr_pwa', action: `quikr_pwa_${pageType}_cityselection`, label: `quikr_pwa_${pageType}_cityselection_click` };
			getEventTrackGA(gaEventObject);
		}
	};

	closeCityPopup = () => {
		this.setState({
			cityPopup: false,
			value: null,
			results: [],
			err: null
		});
	};

	closeNotificationPopup = () => {
		this.setState({
			notificationPopup: false
		});
	};

	openNotificationPopup = () => {
		this.setState({
			notificationPopup: true
		});
	};

	callHeaderfunction = (headerfunction) => {
		this[headerfunction]();
	};

	openHamburger = (e) => {
		e.preventDefault();
		e.stopPropagation();
		e.nativeEvent.stopImmediatePropagation();
		this.setState({
			drawerOpen: true
		});
		const pageType = this.getPageTypeFromProps();
		const gaEventObject = { category: 'quikr_pwa', action: `quikr_pwa_${pageType}_hamburger`, label: `quikr_pwa_${pageType}_hamburger_click` };
		getEventTrackGA(gaEventObject);
	}

	closeHamburger = () => {
		this.setState({
			drawerOpen: false
		});
	}

	handleBackOnClick = (e) => {
		const { handleBackClick, match } = this.props;
		const { router: { history } } = this.context;
		if (handleBackClick) {
			handleBackClick(e, history, match);
		}
		else {
			history.goBack();
		}
	}

	shouldDisplayAddToHomeScreen = () => {
		if (typeof navigator !== "undefined") {
			const userAgent = get(navigator, 'userAgent', '');
			if (!isAndroid(userAgent)) {
				return false;
			}
		}

		const { showAddtoHomeScreen = false } = this.state;
		return showAddtoHomeScreen;
	}

	renderMarketTalkButton = () => {
		if (this.props.marketTalkButton) {
			return <LoadableMarketTalkButton />;
		}
	}

	renderViewinAppFAB = () => {
		if (typeof navigator !== "undefined") {
			const userAgent = get(navigator, 'userAgent', '');
			if (isAndroid(userAgent) && this.props.viewinAppFAB) {
				return <LoadableViewinAppFAB
					city={this.context.quikr.city || 'www'}
					category={this.props.category || 'NA'}
					subcategory={this.props.match.params.type || 'NA'}
					pageType={this.props.gaPageType || 'OTHERS'}
				/>;
			}
		}
	}

	renderQkrAppWidget = () => {
		if (typeof navigator !== "undefined") {
			const userAgent = get(navigator, 'userAgent', '');
			if (isAndroid(userAgent) && this.props.qkrAppWidget) {
				return <LoadableQkrAppWidget
					city={this.context.quikr.city || 'www'}
					category={this.props.category || 'NA'}
					subcategory={this.props.match.params.type || 'NA'}
					pageType={this.props.gaPageType || 'OTHERS'}
				/>;
			}
		}
	}

	renderSwitchBanner = () => {
		if(typeof window !== 'undefined') {
			return <SwitchBanner 
				city={this.context.quikr.city || 'www'} 
				category={this.props.category || 'NA'} 
				subcategory={this.props.match.params.type || 'NA'}
				pageType={this.props.gaPageType || 'OTHERS'}
			/>;
		}
	}

	render(props, state, context) {
		// can get the userInfo from context also this.context.user
		const {
			hasTitle = true,
			CustomTitle = false,
			toolbarItems = true,
			hamburger = true,
			back = false,
			logoHref = null,
			myAccountMenu = {},
			userInfo: user,
			searchCityCallback,
			logoCallback = false,
			hasLogo = true,
			g_id,
			match,
			location = true,
		} = props;
		const { loggedIn: isLoggedIn } = user;

		const { quikr: { city } } = this.context;
		let classes = classnames('mdc-typography');

		const { placeholder = 'Type your city' } = props;
		const { results, err, cityPopup, notificationPopup, value, topCitiesList } = state;
		let gridArray = [];
		for (let i = 1; i <= 12; i++) {
			gridArray.push(<LayoutGrid.Cell desktopCols="1">{i}</LayoutGrid.Cell>);
		}

		const homepageHref = city === 'All India' ? 'https://www.quikr.com' : `https://${city}.quikr.com`;

		return (
			<div class={classes}>
				{this.renderSwitchBanner()}
				{this.renderMarketTalkButton()}
				{this.renderViewinAppFAB()}
				{this.renderQkrAppWidget()}
				<Toolbar>
					<ToolbarRow>
						<ToolbarSection start>
							{hamburger && <a class="mdc-toolbar__icon--menu"
								onClick={this.openHamburger}
							>
								<MenuIcon class="mdc-toolbar__icons" />
							</a>}
							{back && <a class="mdc-toolbar__icon--menu" onClick={this.handleBackOnClick}><Back class="mdc-toolbar__icons" /></a>}
							<ToolbarTitle>

								{hasLogo && (logoCallback ? logoCallback(props, context) : <a href={logoHref ? logoHref : homepageHref} class="logo">
									<Quikr class="mdc-toolbar__icons" />
									<span class="link-text-hidden">Quikr</span>
								</a>)}
								{location && <i class="location"><Location /></i>}
								{CustomTitle !== false && <CustomTitle />}
								{!CustomTitle && hasTitle && <span onClick={this.showCityPopup}>
									{city}
									<i class="mdc-toolbar__arrow" />
								</span>}

							</ToolbarTitle>
							<MediaQuery minWidth={840}>
								<SearchComponent {...this.props.searchProps} />
							</MediaQuery>

						</ToolbarSection>

						{typeof (toolbarItems) === typeof (true) && toolbarItems && <ToolbarSection end>
							{/* {this.shouldDisplayAddToHomeScreen() && <AddToHomeScreen />} */}
							<MyAccountMenu isLoggedIn={isLoggedIn} callHeaderfunction={this.callHeaderfunction} {...myAccountMenu} />
							<Button unelevated compact dense onClick={this.redirectToPostAd}> Post Free Ad </Button>
						</ToolbarSection>}
						{toolbarItems.length > 0 && <ToolbarSection end>
							{toolbarItems}
						</ToolbarSection>}
					</ToolbarRow>
					{/* <Hamburger drawerOpen={state.drawerOpen} onClose={this.closeHamburger} isLoggedIn={isLoggedIn} user={user} /> */}
					{state.drawerOpen !== null && <LoadableHamburger drawerOpen={state.drawerOpen} onClose={this.closeHamburger} isLoggedIn={isLoggedIn} user={user} city={city} showCityPopup={this.showCityPopup} />}
				</Toolbar>
				{cityPopup && <LoadableSearchPopup
					key={'city-popup'}
					show={cityPopup}
					results={results}
					err={err}
					value={value}
					closePopup={this.closeCityPopup}
					placeholder={placeholder}
					handleSearch={this.setCityAndSearch}
					showTopCities={topCitiesList}
					searchCityCallback={searchCityCallback}
					g_id={g_id}
					match={match}
				/>}
				{notificationPopup && <LoadableNotificationPopup closePopup={this.closeNotificationPopup}/>}
				<MediaQuery minWidth={840}>
					<Dialog class="city-dialog" ref={cityDialog=>{this.cityDialog=cityDialog;}} full={true}>
						<CitySelection close={()=>{this.cityDialog.MDComponent.close();}} {...props} handleSearch={this.setCityAndSearch} results={results}/>
					</Dialog>
				</MediaQuery>
			</div>
		);
	}
}

export { Header };

export default showOrHide(Header);


// WEBPACK FOOTER //
// ../q-components/components/header/index.js